import { some } from 'lodash';

export function isAuthorized(userRoles, requiredRoles) {
  if (!requiredRoles || requiredRoles.length === 0) return true;
  return some(requiredRoles, (val) => userRoles.indexOf(val) !== -1);
}
